import { render } from "./ReleaseNotesModal.vue?vue&type=template&id=a80cf0ca&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"

import "./ReleaseNotesModal.vue?vue&type=style&index=0&id=a80cf0ca&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80cf0ca"]])

export default __exports__